import QueryString from 'qs';
import { useHistory, useLocation } from 'react-router-dom';
import ShuttleLayout from '../../components/layout/ShuttleLayout';
import useAxios from '../../hooks/useAxios';
import styled from 'styled-components';
import moment from 'moment';
import {
  IGetBusStatus,
  IGetPassengers,
} from '../../models/shuttleHelper.model';
import Loader from '../../components/Loader';
import ErrorResponse from '../../components/ErrorResponse';
import Button from '../../components/Button';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/rootReducer';
import { useEffect, useState } from 'react';
import {
  getBusStatus,
  getPassengers,
  sendMessages,
  updateBusStatus,
} from '../../api/shuttleHelper.api';
import useNotification from '../../hooks/useNotification';
import { IGetSchedule } from '../../models/shuttleSetting.model';
import { getSchedule } from '../../api/shuttleSetting.api';
import ConfirmStatusModal from '../../components/shuttle/modals/ConfirmStatusModal';
import { addHyphen } from '../../lib/util';
import ShowStudentModal from '../../components/shuttle/modals/ShowStudentModal';
import { useTranslation } from 'react-i18next';

const Block = styled.div`
  margin-bottom: 60px;

  table th,
  table td {
    text-align: center;
    padding: 4px 2px;
  }

  .date {
    font-size: 18px;
    font-weight: 700;
    text-align: center;
  }
`;

const ShuttleDetail = () => {
  const { t, i18n } = useTranslation();
  const history = useHistory();
  const location = useLocation();
  const query = QueryString.parse(location.search, { ignoreQueryPrefix: true });
  const runningCode = Number(query.runningCode);
  const rideGbn = String(query.rideGbn);
  const date = String(query.date);
  const { successNotification, infoNotification } = useNotification();
  const { currentCampus } = useSelector((state: RootState) => state.auth);
  const { data: res, isLoading, error, execute } = useAxios<IGetSchedule>();
  const {
    data: res2,
    isLoading: isLoading2,
    error: error2,
    execute: execute2,
  } = useAxios<IGetPassengers>();
  const {
    data: res3,
    isLoading: isLoading3,
    error: error3,
    execute: execute3,
  } = useAxios<IGetBusStatus>();
  const {
    data: submitRes,
    isLoading: submitIsLoading,
    error: submitError,
    execute: submitExecute,
  } = useAxios();
  const {
    data: submitRes2,
    isLoading: submitIsLoading2,
    error: submitError2,
    execute: submitExecute2,
  } = useAxios();
  const {
    data: submitRes3,
    isLoading: submitIsLoading3,
    error: submitError3,
    execute: submitExecute3,
  } = useAxios();

  const [riders, setRiders] = useState<string[]>([]);
  const [unriders, setUnriders] = useState<string[]>([]);
  const [runningStatus, setRunningStatus] = useState<string>('');
  const [confirmStartVisible, setConfirmStartVisible] = useState(false);
  const [confirmEndVisible, setConfirmEndVisible] = useState(false);
  const [showStudentVisible, setShowStudentVisible] = useState(false);
  const [passengerInfo, setPassengerInfo] = useState<any>();

  useEffect(() => {
    if (currentCampus && runningCode && rideGbn && date) {
      getBusDetail();
    }
  }, [currentCampus, runningCode, rideGbn, date]);

  useEffect(() => {
    if (res3 && !isLoading3) {
      setRunningStatus(res3.data.runningStatus);
    }
  }, [res3, isLoading3]);

  useEffect(() => {
    if (submitRes && !submitIsLoading) {
      getBusDetail();
      setRiders([]);
      setUnriders([]);
      successNotification(t('shuttle.text.23'));
    }
  }, [submitRes, submitIsLoading]);

  useEffect(() => {
    if (submitRes2 && !submitIsLoading2) {
      doGetBusStatus();
      successNotification(t('shuttle.text.24'));
      setConfirmStartVisible(false);
    }
  }, [submitRes2, submitIsLoading2]);

  useEffect(() => {
    if (submitRes3 && !submitIsLoading3) {
      doGetBusStatus();
      successNotification(t('shuttle.text.25'));
      setConfirmEndVisible(false);
    }
  }, [submitRes3, submitIsLoading3]);

  const getBusDetail = () => {
    if (!currentCampus || !runningCode || !rideGbn || !date) return;
    execute(getSchedule(currentCampus, runningCode));
    execute2(getPassengers(currentCampus, runningCode, rideGbn, date));
    execute3(getBusStatus(currentCampus, runningCode, rideGbn, date));
  };

  const doGetBusStatus = () => {
    if (!currentCampus || !runningCode || !rideGbn || !date) return;
    execute3(getBusStatus(currentCampus, runningCode, rideGbn, date));
  };

  const onSetRiders = (memberCode: string) => {
    if (riders.includes(memberCode)) {
      setRiders(riders.filter((item: string) => item !== memberCode));
    } else {
      setRiders([...riders, memberCode]);
      setUnriders(unriders.filter((item: string) => item !== memberCode));
    }
  };

  const onSetUnriders = (memberCode: string) => {
    if (unriders.includes(memberCode)) {
      setUnriders(unriders.filter((item: string) => item !== memberCode));
    } else {
      setUnriders([...unriders, memberCode]);
      setRiders(riders.filter((item: string) => item !== memberCode));
    }
  };

  const onSubmit = () => {
    if (!res2) return;
    if (!riders.length && !unriders.length) {
      return infoNotification(t('shuttle.text.26'));
    }

    const stationInfo: any = [];
    res2.data.forEach((item: any) => {
      item.passengersInfo.forEach((subitem: any) => {
        stationInfo.push({
          runningStationCode: item.runningStationCode,
          memberCode: subitem.passengerMemCode,
        });
      });
    });

    const req: any = [];
    riders.forEach((item: string) => {
      const station: any = stationInfo.find(
        (subitem: any) => subitem.memberCode === item,
      );
      req.push({
        runningCode,
        runningStationCode: station.runningStationCode,
        memberCode: item,
        rideDate: date,
        rideGbn,
        rideYn: 'Y',
      });
    });
    unriders.forEach((item: string) => {
      const station: any = stationInfo.find(
        (subitem: any) => subitem.memberCode === item,
      );
      req.push({
        runningCode,
        runningStationCode: station.runningStationCode,
        memberCode: item,
        rideDate: date,
        rideGbn,
        rideYn: 'N',
      });
    });

    submitExecute(sendMessages(currentCampus, req));
  };

  const getOkLabel = () => {
    switch (rideGbn) {
      case 'UP':
        return t('shuttle.text.10');
      case 'DN':
        return t('shuttle.text.11');
      default:
        return '';
    }
  };

  const getNgLabel = () => {
    switch (rideGbn) {
      case 'UP':
        return t('shuttle.text.27');
      case 'DN':
        return t('shuttle.text.28');
      default:
        return '';
    }
  };

  const getStatusLabel = () => {
    switch (runningStatus) {
      case 'PREPARE':
        return t('shuttle.text.29');
      case 'RUNNING':
        return t('shuttle.text.30');
      case 'END':
        return t('shuttle.text.31');
      default:
        return '';
    }
  };

  const onSubmitBusStatus = () => {
    switch (runningStatus) {
      case 'PREPARE':
        setConfirmStartVisible(true);
        break;
      case 'RUNNING':
        if (hasSentAll()) {
          setConfirmEndVisible(true);
        } else {
          return infoNotification(t('shuttle.text.32'));
        }
        break;
    }
  };

  const submitBusStatus = () => {
    runningStatus === 'PREPARE'
      ? submitExecute2(
          updateBusStatus(currentCampus, runningCode, {
            runningDiv: 'SRT',
            selectDate: date,
            rideDate: date,
            rideGbn,
          }),
        )
      : submitExecute3(
          updateBusStatus(currentCampus, runningCode, {
            runningDiv: 'END',
            selectDate: date,
            rideDate: date,
            rideGbn,
          }),
        );
  };

  const hasSentAll = () => {
    if (!res2?.data) return false;
    return res2.data.every((item: any) =>
      item.passengersInfo.every((subitem: any) => subitem.rideYn),
    );
  };

  return (
    <ShuttleLayout>
      {isLoading ||
      isLoading2 ||
      isLoading3 ||
      submitIsLoading ||
      submitIsLoading2 ||
      submitIsLoading3 ? (
        <Loader />
      ) : null}
      <ErrorResponse error={error} />
      <ErrorResponse error={error2} />
      <ErrorResponse error={error3} />
      <ErrorResponse error={submitError} />
      <ErrorResponse error={submitError2} />
      <ErrorResponse error={submitError3} />

      <Block className="w-100">
        <div className="date">{moment(date).format(i18n.language === 'ko' ? 'YYYY년 M월 D일' : 'YYYY. M. D.')}</div>
        <div className="mt-4">
          <table className="table-shuttle">
            <tbody>
              <tr>
                <th>{t('shuttle.text.33')}</th>
                <th>{t('shuttle.text.34')}</th>
                <th>{t('shuttle.text.35')}</th>
                <th>{t('shuttle.text.36')}</th>
              </tr>
              <tr>
                <td>{res?.data.lineName}</td>
                <td>{res?.data.lineTime}</td>
                <td>
                  {
                    rideGbn === 'UP'
                      ? res?.data.attendMemKorName
                      : res?.data.overMemKorName
                  }
                </td>
                <td>
                  {
                    rideGbn === 'UP'
                      ? addHyphen(res?.data.attendMemPhone)
                      : addHyphen(res?.data.overMemPhone)
                  }
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="mt-4">
          <table className="table-shuttle">
            <tbody>
              <tr>
                <th>{t('shuttle.text.37')}</th>
                <th>{t('shuttle.text.38')}</th>
                <th>{rideGbn === 'UP' ? t('shuttle.text.8') : t('shuttle.text.9')} {t('shuttle.text.39')}</th>
              </tr>
              {res2?.data ? (
                res2.data.map((item, index) => (
                  <>
                    <tr key={index}>
                      <td rowSpan={item.passengersInfo.length}>
                        {item.stationName}
                      </td>
                      <td
                        onClick={() => {
                          setPassengerInfo(item.passengersInfo[0]);
                          setShowStudentVisible(true);
                        }}
                      >
                        {item.passengersInfo[0].passengerKorName}
                      </td>
                      <td>
                        {item.passengersInfo[0].rideYn ? (
                          item.passengersInfo[0].rideYn === 'Y' ? (
                            getOkLabel()
                          ) : (
                            getNgLabel()
                          )
                        ) : (
                          <>
                            <Button
                              onClick={() =>
                                onSetRiders(
                                  item.passengersInfo[0].passengerMemCode,
                                )
                              }
                              className={
                                'btn btn-sm btn-w70p mr-1 ' +
                                (riders.includes(
                                  item.passengersInfo[0].passengerMemCode,
                                )
                                  ? 'btn-primary'
                                  : 'btn-secondary')
                              }
                              text={getOkLabel()}
                              disabled={runningStatus !== 'RUNNING'}
                            />
                            <Button
                              onClick={() =>
                                onSetUnriders(
                                  item.passengersInfo[0].passengerMemCode,
                                )
                              }
                              className={
                                'btn btn-sm btn-w70p ' +
                                (unriders.includes(
                                  item.passengersInfo[0].passengerMemCode,
                                )
                                  ? 'btn-primary'
                                  : 'btn-secondary')
                              }
                              text={getNgLabel()}
                              disabled={runningStatus !== 'RUNNING'}
                            />
                          </>
                        )}
                      </td>
                    </tr>
                    {item.passengersInfo.slice(1).map((subitem, index) => (
                      <tr key={index + 1}>
                        <td
                          style={{ borderLeft: '1px solid black' }}
                          onClick={() => {
                            setPassengerInfo(subitem);
                            setShowStudentVisible(true);  
                          }}
                        >
                          {subitem.passengerKorName}
                        </td>
                        <td>
                          {subitem.rideYn ? (
                            subitem.rideYn === 'Y' ? (
                              getOkLabel()
                            ) : (
                              getNgLabel()
                            )
                          ) : (
                            <>
                              <Button
                                onClick={() =>
                                  onSetRiders(subitem.passengerMemCode)
                                }
                                className={
                                  'btn btn-sm btn-w70p mr-1 ' +
                                  (riders.includes(subitem.passengerMemCode)
                                    ? 'btn-primary'
                                    : 'btn-secondary')
                                }
                                text={getOkLabel()}
                                disabled={runningStatus !== 'RUNNING'}
                              />
                              <Button
                                onClick={() =>
                                  onSetUnriders(subitem.passengerMemCode)
                                }
                                className={
                                  'btn btn-sm btn-w70p ' +
                                  (unriders.includes(subitem.passengerMemCode)
                                    ? 'btn-primary'
                                    : 'btn-secondary')
                                }
                                text={getNgLabel()}
                                disabled={runningStatus !== 'RUNNING'}
                              />
                            </>
                          )}
                        </td>
                      </tr>
                    ))}
                  </>
                ))
              ) : (
                <tr>
                  <td colSpan={3}>{t('shuttle.text.40')}</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <div className="footer">
          <table>
            <colgroup>
              <col width="33%" />
              <col width="*" />
              <col width="33%" />
            </colgroup>
            <tbody>
              <tr>
                <td
                  onClick={() =>
                    history.push(
                      `/search?runningCode=${runningCode}&rideGbn=${rideGbn}&date=${date}`,
                    )
                  }
                >
                  {t('shuttle.text.41')}
                </td>
                <td onClick={() => onSubmitBusStatus()}>
                  {getStatusLabel()}
                </td>
                <td onClick={onSubmit}>{t('shuttle.text.42')}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </Block>

      {/* 운행 시작 확인 */}
      {confirmStartVisible &&
        <ConfirmStatusModal
          visible={confirmStartVisible}
          setVisible={setConfirmStartVisible}
          submitBusStatus={submitBusStatus}
          rideGbn={rideGbn}
          isStart
        />
      }
      {/* 운행 종료 확인 */}
      {confirmEndVisible &&
        <ConfirmStatusModal
          visible={confirmEndVisible}
          setVisible={setConfirmEndVisible}
          submitBusStatus={submitBusStatus}
          rideGbn={rideGbn}
          isStart={false}
        />
      }
      {/* 학생 정보 표시 */}
      {showStudentVisible &&
        <ShowStudentModal
          visible={showStudentVisible}
          setVisible={setShowStudentVisible}
          passengerInfo={passengerInfo}
        />
      }
    </ShuttleLayout>
  );
};

export default ShuttleDetail;
